import { GetRentalPolicyUseCase } from '@/core/domain/rental-policy/usecases/getRentalPolicy.usecase';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { of, switchMap } from 'rxjs';

@Component({
    selector: 'fe-rental-policy',
    templateUrl: './rental-policy.component.html',
    styleUrls: ['./rental-policy.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class RentalPolicyComponent implements OnInit {
    public breadcrumbs = [
        {
            label: 'fe_breadcrumb_view_customer_support',
            url: 'contact-us-and-faqs',
        },
        {
            label: 'fe_breadcrumb_view_questions',
            url: 'questions',
        },
        {
            label: 'fe_breadcrumb_view_rental_policy',
            url: 'questions/car-rental-conditions-and-policies',
        },
    ];

    public rentalPolicyContent = '';

    constructor(
        private readonly getRentalPolicyUseCase: GetRentalPolicyUseCase,
    ) {}

    public ngOnInit(): void {
        this.getRentalPolicyUseCase
            .execute()
            .pipe(
                switchMap((response) => {
                    this.rentalPolicyContent = response.data.rentalPolicy;
                    return of(response);
                }),
            )
            .subscribe();
    }
}
